import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class SingleWorkType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      prevPage: 'singe',
    };
  }

  componentDidMount() {
    this.setState({ prevPage: this.props.params.prevPage });
  }

  handleTitleType(e, key) {
    const { fields } = this.props;

    let titleTypes = fields.titleTypes || {};
    titleTypes[key] = e.target.value;

    this.props.assignAttribute('titleTypes', { ...titleTypes });
  }

  handleNext() {
    this.props.hideAlert();

    if (this.state.prevPage === 'single') {
      this.props.assignAttribute('workType', this.state.prevPage);
      this.props.router.push('/copyright-reg/publish');
    } else {
      this.props.assignAttribute('workType', this.state.prevPage);
      this.props.router.push('/copyright-reg/publish');
    }
  }

  handleBack() {
    this.props.router.goBack();
  }

  render() {
    const { fields } = this.props;
    const titleTypes = fields.titleTypes || {};

    return (
      <div className="select-work work-title">
        <Heading text="Tell Us More About These Titles" />
        <div className="content">
          <Form>
            <FormGroup>
              <ul>
                <li>
                  {/* {this.state.prevPage === 'single'
                                        ? <div>If the works are part of a larger collection (i.e. an album) what is the name of that collection?</div>
                                        : <div><span className="text-red">*&nbsp;</span>If the works are part of a larger collection (i.e. an album) what is the name of that collection?</div>
                                    } */}
                  <div>
                    If the works are part of a larger collection (i.e. an album)
                    what is the name of that collection?
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.largerWork || ''}
                    onChange={(e) => this.handleTitleType(e, 'largerWork')}
                    // placeholder={this.state.prevPage === 'single' ? 'Type Here' : `Give your collection a name (for example, "Works of Adam Smith")`}
                    placeholder="Type Here"
                  />
                </li>
                <li>
                  <div>
                    If the works are part of a series, what is the series title?
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.series || ''}
                    onChange={(e) => this.handleTitleType(e, 'series')}
                    placeholder="Type Here"
                  />
                </li>
                <li>
                  <div>
                    If the works have previous/alternate titles, list them
                    below:
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.previousAlt || ''}
                    onChange={(e) => this.handleTitleType(e, 'previousAlt')}
                    placeholder="Type Here"
                  />
                </li>
              </ul>
            </FormGroup>
          </Form>
        </div>
        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handleBack()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleWorkType);



// WEBPACK FOOTER //
// src/components/Copyright/SingleWorkType.jsx